/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListBudgetsModel {
    getFixupPrototypeFunction() { return ListBudgetsModel.fixupPrototype; }

    static newInstance(model: Partial<ListBudgetsModel>): ListBudgetsModel {
        let obj = Object.assign(new ListBudgetsModel(), model);
        ListBudgetsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListBudgetsModel>): ListBudgetsModel {
        if (!model) return null;
        return ListBudgetsModel.newInstance(<ListBudgetsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListBudgetsModel) {
        if (!obj) return;

        models.ListBudgetsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListBudgetsModel): boolean {
        Object.setPrototypeOf(obj, ListBudgetsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_amount === undefined) {
            this.budget_amount = 0;
        }
        if (this.actual_amount === undefined) {
            this.actual_amount = 0;
        }
        if (this.forecasted_amount === undefined) {
            this.forecasted_amount = 0;
        }
        if (typeof this.last_threshold === "string") {
            this.last_threshold = new Date(<string><any>this.last_threshold);
        }
        if (this.scope) {
            models.BudgetScopeDetails.fixupPrototype(this.scope);
        }
    }

    /**
     * budget name
     */
    budget_name: string;

    /**
     * Cost metric used to calculate the budget amount
     */
    billing_source: string;

    /**
     * budget type
     */
    budget_type: string;

    /**
     * Specify the budget frequency. Example: 'budget frequency':'Daily' Allowed values - Daily,Monthly,Quarterly,Annually
     */
    budget_frequency: string;

    /**
     * The period the amounts on this row cover. NA for daily budgets
     */
    budget_time_period: string;

    /**
     * budget amount
     */
    budget_amount: number;

    /**
     * budget actual amount
     */
    actual_amount: number;

    /**
     * budget forecasted amount
     */
    forecasted_amount: number;

    /**
     * budget currency
     */
    currency: string;

    /**
     * budget start data
     */
    start_date: string;

    /**
     * budget end date
     */
    end_date: string;

    /**
     * last threshold
     */
    last_threshold: Date;

    /**
     * budget created status
     */
    status: string;

    /**
     * budget uri
     */
    budget_uri: string;

    /**
     * budget created at
     */
    created_at: string;

    /**
     * metadata to maintain step
     */
    metadata: any;

    /**
     * budget id
     */
    budget_id: string;

    /**
     * budget engine can be Cloud_Native or System
     */
    budget_engine: models.BudgetEngine;

    /**
     * budget scope
     */
    budget_scope: models.BudgetScope;

    /**
     * scope of the budget further defined for each scope
     */
    scope: models.BudgetScopeDetails;

}
